import * as React from 'react';
import LoadingWithMessage from '../misc/components/LoadingWithMessage';
import FailureWithMessage from '../misc/components/FailureWithMessage';
import { UpdateStatus } from './DevicesNewReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact } from '@fortawesome/free-brands-svg-icons';
import { faDownload, faRepeat } from '@fortawesome/free-solid-svg-icons';

export interface PairDeviceLinkModalProps {
    squirrelUrl: string;
    show: boolean;
    updateStatus: UpdateStatus;
    onClose: () => void;
}

export const PairDeviceLinkModal = (props: PairDeviceLinkModalProps) => {
    if (props.updateStatus === UpdateStatus.Updating) {
        return <LoadingWithMessage message="Updating Device Link software..." />
    } else if (props.updateStatus === UpdateStatus.FailedToUpdate) {
        return (
            <FailureWithMessage message="Device Link failed to update. Please contact Vitalograph Support Services" />
        );
    } else if (props.show) {
        return (
            <>
                <div className="modal-backdrop fade in"></div>
                <div id="DeviceLinkConnectionDialog" className="modal show">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h2 className="text-primary">Setup Connection</h2>
                                <p>Unable to connect to DeviceLink, this can be caused by the software not being installed or running.</p>
                                <ol className="posh-list">
                                    <li>Download and run the DeviceLink setup:
                                        <br />
                                        <br />
                                        <a className="btn btn-primary" href={props.squirrelUrl}>
                                            <FontAwesomeIcon icon={faDownload} aria-hidden="true" />&nbsp;
                                            DeviceLink Setup
                                        </a>
                                    </li>
                                </ol>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={() => props.onClose()}><FontAwesomeIcon icon={faRepeat} /> Retry</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return null;
    }
}
